import React from 'react';
import { Header, PrivacyPolicy, SubFooter } from 'Atoms/';

export default function privacyPolicy() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        url="diamondhead"
      />
      <PrivacyPolicy />
      <SubFooter name="Diamond Head State Monument" url="diamondhead" />
    </div>
  );
}
